import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { Link, useHistory, useParams } from "react-router-dom";

//UI
import { Form, Divider, Header, Loader, Button, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

//Actions
import { createGuide } from "../../../redux/actions/catalogs/guide/createGuide";
import { fetchGuide, initialStateGuide } from "../../../redux/actions/catalogs/guide/fetchGuide";
import { updateGuide } from "../../../redux/actions/catalogs/guide/updateGuide";

// Resources
import { scrollToTop } from "../../resources/utils";
import InputMask from "react-input-mask";

export default function GuideForm() {
  const { t } = useTranslation();
  let history = useHistory();
  let { guide_id } = useParams();
  const { control, setValue, register, handleSubmit, errors } = useForm({
    defaultValues: {
      cellular_phone: "(+593)",
    },
  });
  const guideState = useSelector((state) => state.guideReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (guide_id) {
      dispatch(fetchGuide(guide_id));
    }
    scrollToTop();

    return () => {
      dispatch(initialStateGuide());
    };
  }, []);

  useEffect(() => {
    setValue('first_name', guideState.guide.first_name)
    setValue('last_name', guideState.guide.last_name)
    setValue('document_number', guideState.guide.document_number)
    setValue('cellular_phone', guideState.guide.cellular_phone)
    setValue('active', guideState.guide.active)
  }, [guideState.guide]);

  if (guideState.fetching) {
    return <Loader active inline />;
  }

  const onSubmit = (data) => {
    if (guide_id) {
      dispatch(updateGuide(guide_id, data));
    } else {
      dispatch(createGuide(data));
    }
  };

  if (guideState.message === "resource created successfully" || guideState.message === "resource updated successfully") {
    history.push("/guides");
  }

  return (
    <>
      {guideState.error ? (
        <Message negative content={t(guideState.error)} />
      ) : (
        ""
      )}
      <Header as='h3' dividing>{t("guide_title")}</Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Header as='h4' dividing color='grey'>{t("general_information_tag")}</Header>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>{t("guide_name")}</label>
            <input name="first_name" placeholder={t("guide_name")} maxLength={100} ref={register({ required: true })} autoFocus />
            {errors.first_name && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field required>
            <label>{t("guide_lastName")}</label>
            <input name="last_name" placeholder={t("guide_lastName")} maxLength={100} ref={register({ required: true })} />
            {errors.last_name && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field required>
            <label>{t("guide_identification_card")}</label>
            <input name="document_number" placeholder={t("guide_identification_card")} maxLength={50} ref={register({ required: true })} />
            {errors.document_number && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field>
            <label>{t("guide_phone")}</label>
            <Controller
              as={InputMask}
              name="cellular_phone"
              control={control}
              defaultValue="(+593) "
              mask="(+593) 99-999-9999"
              maskChar=""
              alwaysShowMask={false}
              beforeMaskedValueChange={(newState) => {
                const { value } = newState;
                if (!value.startsWith("(+593) ")) {
                  newState.value = "(+593) ";
                }
                return newState;
              }}
              className="border rounded px-3 py-2 w-full"
              placeholder="(+593) 99-999-9999"
            />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <label>{t("active_tag")}</label>
            <div className="ui checkbox">
              <input type="checkbox" name="active" defaultChecked={guideState.guide.active === 1} ref={register} />
              <label></label>
            </div>
          </Form.Field>
        </Form.Group>
        <Divider variant="middle" />

        <Button primary type="submit" loading={guideState.processing ? true : false}>{t("save_button")}</Button>
        <Link to={"/guides"}><Button>{t("canceled_button")}</Button></Link>
      </Form>
    </>
  );
}
